<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<!-- 选项卡 -->
			<div class="navBox f-ct">
				<p @click="newsType=1" :class="newsType==1?'a':''">学员信息</p>
				<p @click="newsType=2,memberCertificateList(1)" :class="newsType==2?'a':''">发证记录</p>
				<p @click="newsType=3" :class="newsType==3?'a':''">开票信息</p>
			</div>
			<!-- 用户信息 -->
			<div class="userMsg" v-if="newsType==1">
				<!-- 审核状态 -->
				<div class="shStatus f-ct" v-if="manInfo.auditStatus==0">
					<el-image class="i1" :src="require('@/static/icon110.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon111.png')"></el-image>
					<p>审核状态：审核中</p>
				</div>
				<div class="shStatus f-ct" style="background: #FF5F5A;" v-if="manInfo.auditStatus==2">
					<el-image class="i1" :src="require('@/static/icon110.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon111.png')"></el-image>
					<p>审核状态：审核不通过&emsp;原因：{{manInfo.auditInfo}}</p>
				</div>
				<!-- 基础信息 -->
				<div class="f-bct">
					<div class="userImg">
						<div class="lable">头像<span>（点击修改）</span></div>
						<div class="detail">
							<el-upload accept="image/png, image/jpeg" 
							class="avatar-uploader"
							:action="uplink"
							:show-file-list="false"
							:on-change="uplinkportrait">
								<el-image v-if="!portrait" :src="require('@/static/img2.png')"></el-image>
								<el-image v-else fit="cover" :src="portrait"></el-image>
							</el-upload>
						</div>
					</div>
					<div class="company">
						<div class="lable">企业信息</div>
						<div class="detail f-ct">
							<el-image :src="companyInfo.logo"></el-image>
							<div class="r">
								<p class="name">{{companyInfo.companyName}}</p>
								<p class="t1">企业联系人：{{companyInfo.contact}}</p>
								<p class="t1">企 业 电 话：{{companyInfo.mobile}}</p>
								<p class="t1">企 业 地 址：{{companyInfo.provinceName}}{{companyInfo.cityName}}{{companyInfo.districtName}}{{companyInfo.address}}</p>
							</div>
						</div>
					</div>
				</div>
				<!-- 表单 -->
				<div class="f-bct">
					<div class="formBox" @click="hbMobile = true">
						<div class="lable">手机号码</div>
						<div class="detail f-ct">
							<el-input type="text" disabled :value="manInfo.mobile" placeholder="请输入手机号码"></el-input>
							<div class="anniu">更换</div>
						</div>
					</div>
					<div class="formBox" @click="hbPwd = true">
						<div class="lable">登录密码</div>
						<div class="detail f-ct">
							<el-input type="password" disabled value="123456789" placeholder="请输入登录密码"></el-input>
							<div class="anniu">重置</div>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">姓名</div>
						<div class="detail f-ct">
							<el-input type="text" disabled v-model="name" placeholder="请输入姓名"></el-input>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">身份证号</div>
						<div class="detail f-ct">
							<el-input type="text" disabled v-model="identityCardCode" placeholder="请输入身份证号"></el-input>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">性别</div>
						<div class="detail f-ct">
							<!-- <el-input type="text" disabled :value="gender==1?'男':'女'" placeholder="可从身份证识别"></el-input> -->
							<el-select style="width: 100%;" disabled v-model="gender" placeholder="请选择">
								<el-option
									v-for="item in genderArr"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">出生日期</div>
						<div class="detail f-ct">
							<!-- <el-input type="text" :value="birthday" placeholder="可从身份证识别"></el-input> -->
							<el-date-picker
							disabled
							style="width: 100%;"
							v-model="birthday"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">职称</div>
						<div class="detail f-ct">
							<el-select v-model="jobName" placeholder="请选择">
								<el-option
									v-for="item in optionsZC"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="jobName" placeholder="请输入职称"></el-input> -->
						</div>
					</div>
					<div class="formBox">
						<div class="lable">职务</div>
						<div class="detail f-ct">
							<el-select v-model="positionName" placeholder="请选择">
								<el-option
									v-for="item in optionsZW"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="positionName" placeholder="请输入职务"></el-input> -->
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">申请类目</div>
						<div class="detail f-ct">
							<el-cascader
							style="width: 100%;"
							placeholder="请选择您的申请类别"
							:props="{children:'childList',label:'categoryName',value:'id'}"
							v-model="catVar"
							:options="catArr"></el-cascader>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">学历</div>
						<div class="detail f-ct">
							<el-select v-model="educationName" placeholder="请选择">
								<el-option
									v-for="item in optionsXL"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="educationName" placeholder="请输入学历"></el-input> -->
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">省市区</div>
						<div class="detail" v-if="regionList.length">
							<el-cascader
							style="width: 100%;"
							placeholder="请选择地址"
							:props="{children:'childList',label:'name',value:'id'}"
							v-model="regionVal"
							:options="regionList"></el-cascader>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">详细地址</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="address" placeholder="请输入详细地址"></el-input>
						</div>
					</div>
				</div>
				<!-- 基础信息 -->
				<div class="f-bct">
					<div class="userImgBox f-ct">
						<div class="itm">
							<div class="lable">身份证正面扫描件</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="idCardF1">
									<el-image v-if="!identityCardFrontImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="identityCardFrontImage"></el-image>
								</el-upload>
							</div>
						</div>
						<div class="itm">
							<div class="lable">身份证反面扫描件</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="idCardF2">
									<el-image v-if="!identityCardBackImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="identityCardBackImage"></el-image>
								</el-upload>
							</div>
						</div>
					</div>
					<div class="userImgBox f-ct">
						<div class="itm">
							<div class="lable">学历扫描件</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="byzimgF">
									<el-image v-if="!diplomaImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="diplomaImage"></el-image>
								</el-upload>
							</div>
						</div>
						<div class="itm">
							<div class="lable">社保扫描件</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="shebaoImgf">
									<el-image v-if="!socialSecurityImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="socialSecurityImage"></el-image>
								</el-upload>
							</div>
						</div>
						<div class="itm">
							<div class="lable">体检报告照片</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="tjImgf">
									<el-image v-if="!physicalImage" :src="require('@/static/icon7.png')"></el-image>
									<el-image v-else fit="cover" :src="physicalImage"></el-image>
								</el-upload>
							</div>
						</div>
						<!-- <div class="itm">
							<div class="lable">签名</div>
							<div class="detail">
								<el-image v-if="!signatureImage" :src="require('@/static/img2.png')"></el-image>
								<el-image v-else fit="cover" :src="signatureImage"></el-image>
							</div>
						</div> -->
					</div>
				</div>
				<div class="f-bct">
					<div class="userImgBox f-ct" style="width: 100%;">
						<div class="itm2">
							<div class="lable">劳务合同照片</div>
							<p class="tips">(仅支持上传JPG、PNG格式)</p>
							<div class="detail f-ct">
								<!-- <el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="ldhtimgF">
									<el-image v-if="!laborContractImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="laborContractImage"></el-image>
								</el-upload> -->
								
								
								<el-upload accept="image/png, image/jpeg" 
								:action="uplink"
								list-type="picture-card"
								:file-list="laborContractImageCS"
								:on-preview="handlePictureCardPreview"
								:on-success="ldhtimgF"
								:on-remove="handleRemove">
								<!-- <i class="el-icon-plus"></i> -->
								<el-image :src="require('@/static/icon10.png')"></el-image>
								</el-upload>
								
							</div>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="userImgBox f-ct" @click="hbQianmin= true" style="width: 100%;">
						<div class="itm2">
							<div class="lable">签名</div>
							<div class="detail f-ct">
								<el-image v-if="!signatureImage" :src="require('@/static/icon7.png')"></el-image>
								<el-image v-else :src="signatureImage"></el-image>
							</div>
						</div>
					</div>
				</div>
				<div class="pageAnniuBox f-ct">
					<!-- <div class="b1">编辑资料</div> -->
					<div class="b1" @click="authMemberprofile">保存修改</div>
					<!-- <div class="b2">取消</div> -->
				</div>
			</div>
			<!-- 发证记录 -->
			<div class="zw" v-if="(!zsList.length)&&newsType==2">
				<el-image :src="require('@/static/zw.png')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			<div class="cardTable" v-if="newsType==2&&zsList.length">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">证书编号</p>
					<p class="t3">课程名称</p>
					<p class="t4">所在班级</p>
					<p class="t5">课程类型</p>
					<p class="t6">班主任</p>
					<p class="t7">发证时间</p>
					<p class="t8">操作</p>
				</div>
				<div class="td f-ct" v-for="(item,index) in zsList">
					<div class="t1">{{item.id}}</div>
					<div class="t2">{{item.certificateNumber}}</div>
					<div class="t3">{{item.course.name}}</div>
					<div class="t4">{{item.courseClass.name}}</div>
					<div class="t5">{{item.course.categoryName}}</div>
					<div class="t6">{{item.courseClass.classTeacherName}}</div>
					<div class="t7">{{item.createTime}}</div>
					<div class="t8 f-ct">
						<p class="p1" @click="onPreview(item.certificateImage)">查看</p>
						<p class="p1" style="margin-left: 10px;" @click="getNewsDetail(item.certificateImage)">下载</p>
					</div>
				</div>
			</div>
			<div class="fenye" v-if="newsType==2">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>
			<!-- 开票信息 -->
			<div class="kpBox" v-if="newsType==3">
				<div class="pageAnniuBox f-ct">
					<div class="b1" style="width: auto;" @click="link('/userMsgKp')">添加开票信息</div>
				</div>
				<div class="zw" v-if="!kpxxList.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="kfpTable" v-if="kpxxList.length">
					<div class="th f-ct">
						<p class="t1">序号</p>
						<p class="t2">开票信息类型</p>
						<p class="t3">发票抬头</p>
						<p class="t4">纳税人识别号</p>
						<p class="t6">邮箱</p>
						<p class="t7">操作</p>
					</div>
					<div class="td f-ct" v-for="(item,index) in kpxxList">
						<div class="t1">{{item.id}}</div>
						<div class="t2" v-if="item.invoiceType==1">普通发票(个人)</div>
						<div class="t2" v-if="item.invoiceType==2">普通发票(单位)</div>
						<div class="t2" v-if="item.invoiceType==3">专用发票(单位)</div>
						<div class="t3">{{item.title}}</div>
						<div class="t4" v-if="item.invoiceType==1">/</div>
						<div class="t4" v-if="item.invoiceType!=1">{{item.code}}</div>
						<div class="t6" v-if="item.invoiceType!=3">{{item.email}}</div>
						<div class="t6" v-if="item.invoiceType==3">/</div>
						<div class="t7">
							<p class="txt1" @click="link('/userMsgKp',{id:item.id})">编辑</p>
							<p class="bor"></p>
							<p class="txt2" @click="memberInvoicedelete(item.id)">删除</p>
						</div>
					</div>
				</div>
				<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
				</div>
			</div>
		</div>
		<!-- 弹出框 重置密码 -->
		<div class="maskBg" @click="hbPwd=false" v-if="hbPwd"></div>
		<div class="subTips" v-if="hbPwd">
			<div class="hbTit f-bct">
				<p>重置密码</p>
				<el-image class="cha" @click="hbPwd=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<!-- <div class="iptBox">
				<div class="lable">输入原密码</div>
				<div class="ipt">
					<el-input type="password" v-model="mobile" placeholder="请输入原密码"></el-input>
				</div>
			</div> -->
			<div class="iptBox">
				<div class="lable">手机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="code" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="authMemberregCaptcha">{{codetxt}}</div>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">输入新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="password" placeholder="请输入新密码"></el-input>
				</div>
			</div>
			<!-- <div class="iptBox">
				<div class="lable">确认新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="mobile" placeholder="请确认新密码"></el-input>
				</div>
			</div> -->
			<div class="btnBox f-ct">
				<div class="b1" @click="hbPwd=false">返回</div>
				<div class="b2" @click="authMemberrestPassword">确认重置</div>
			</div>
		</div>
		<!-- 弹出框 更换手机号 -->
		<div class="maskBg" @click="hbMobile=false" v-if="hbMobile"></div>
		<div class="subTips" v-if="hbMobile">
			<div class="hbTit f-bct">
				<p>更换手机号</p>
				<el-image class="cha" @click="hbMobile=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="nowpone">当前绑定手机号:{{mobileSuss}}</div>
			<div class="iptBox">
				<div class="lable">旧机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="ocode" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="ocodetxtF()">{{ocodetxt}}</div>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">新手机号码</div>
				<div class="ipt">
					<el-input type="text" v-model="newMobile" placeholder="请输入新手机号码"></el-input>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">手机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="newMobileCode" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="ncodetxtF()">{{ncodetxt}}</div>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbMobile=false;">返回</div>
				<div class="b2" @click="authMemberupdateMobile">提交</div>
			</div>
		</div>
		
		<el-image-viewer
		v-if="showViewer" 
		:on-close="closeViewer" 
		:url-list="[url]" />
		
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbQianmin=false" v-if="hbQianmin"></div>
		<div class="subTipsQm" v-if="hbQianmin">
			<div class="hbTit f-bct">
				<p>签名</p>
				<el-image class="cha" @click="hbQianmin=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<!-- <div class="qianMin">
				<vue-esign
				ref="esign"
				style="border: 1px dashed #c2c1c1;"
				:height="360"
				/>
			</div> -->
			<div class="qianMin">
				<vue-esign
				ref="esign"
				style="border: 1px dashed #c2c1c1;"
				:height="360"
				/>
			</div>
			<!-- <div class="qianMin" v-if="signatureImage">
				<el-image :src="signatureImage"></el-image>
			</div> -->
			<div class="t1">提示：请用在虚线内签名</div>
			<div class="hbbtnBox f-ct">
				<div class="b1" @click="handleReset()">重写</div>
				<div class="b2" @click="handleGenerate">确定</div>
			</div>
		</div>
		
	</div>
</template>
<script>
import { authMemberInfo,
authMemberprofile,
regioncityTree,
coursecategoryList,
memberCertificateList,
memberInvoiceList,
memberInvoicedelete,
authMemberregCaptcha,
authMemberupdateMobile,
authMemberrestPassword
} from "/src/api/api.js"
import axios from "axios";
import vueEsign from 'vue-esign'
let oic;
let nic;
let ic;
var nub = 120;
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
	components: { ElImageViewer,vueEsign },
	data(){
		return {
			hbQianmin:false,
			showViewer: false,// 显示查看器
			newsType:1,
			hbPwd:false,
			hbMobile:false,
			// 用户信息
			manInfo:'',
			companyInfo:'',
			// 表单
			// 申请类别
			catArr:[],
			catVar:'',
			// 地址
			regionList:[],
			regionVal:'',
			// 其他
			portrait:'',
			name:'',
			identityCardCode:'',
			genderArr:[
				{
					value: 0,
					label: '未知'
				},
				{
					value: 1,
					label: '男'
				},
				{
					value: 2,
					label: '女'
				},
			],
			gender: 1,
			birthday:'',
			jobName:'',
			positionName:'',
			educationName:'',
			address:'',
			identityCardFrontImage:'',
			identityCardBackImage:'',
			diplomaImage:'',
			laborContractImageCS:'',
			laborContractImage:[],
			socialSecurityImage:'',
			physicalImage:'',
			signatureImage:'',
			// 证书列表
			zsList:[],
			// 开票信息
			kpxxList:[],
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 修改手机号
			mobileSuss:'',
			mobile:'',
			ocodetxt:'发送验证码',
			ocode:'',
			newMobile:'',
			ncodetxt:'发送验证码',
			newMobileCode:'',
			// 重置密码
			codetxt:'发送验证码',
			code:'',
			password:'',
			
			// 学历
			optionsXL: [
				{value: '小学',label: '小学'},
				{value: '初中',label: '初中'},
				{value: '高中',label: '高中'},
				{value: '专科',label: '专科'},
				{value: '本科',label: '本科'},
				{value: '硕士研究生',label: '硕士研究生'},
				{value: '博士研究生',label: '博士研究生'},
			],
			// valueXL: '小学',
			// 职称
			optionsZC: [
				{value: '正高级工程师',label: '正高级工程师'},
				{value: '高级工程师',label: '高级工程师'},
				{value: '工程师',label: '工程师'},
				{value: '助理工程师',label: '助理工程师'},
				{value: '技术员',label: '技术员'},
				{value: '无',label: '无'},
			],
			// valueZC: '技术员',
			// 职务
			optionsZW: [
				{value: '总裁',label: '总裁'},
				{value: '副总裁',label: '副总裁'},
				{value: '总裁助理',label: '总裁助理'},
				{value: '总经理',label: '总经理'},
				{value: '副总经理',label: '副总经理'},
				{value: '总经理助理',label: '总经理助理'},
				{value: '经理/站长',label: '经理/站长'},
				{value: '安全员',label: '安全员'},
				{value: '班组长',label: '班组长'},
				{value: '普通员工',label: '普通员工'},
			],
			// valueZW: '普通员工',
		}
	},
	mounted() {
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		this.newsType = this.$route.query.type||1
		// 获取信息
		this.regioncityTree()
		this.coursecategoryList()
		this.memberCertificateList()
		this.memberInvoiceList()
		setTimeout(()=>{
			this.getinfo()
		},500)
	},
	methods:{
		// 显示查看器
		onPreview(item) {
			this.url = item
			this.showViewer = true
		},
		// 关闭查看器
		closeViewer() {
			this.showViewer = false
		},
		// 重置密码
		async authMemberrestPassword(){
			const res = await authMemberrestPassword({
				code:this.code,
				mobile:this.mobile,
				password:this.password,
			});
			this.hbPwd=false
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 修改手机
		async authMemberupdateMobile(){
			const res = await authMemberupdateMobile({
				code:this.ocode,
				newMobile:this.newMobile,
				newMobileCode:this.newMobileCode,
			});
			this.hbMobile=false
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async authMemberregCaptcha(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		async ocodetxtF(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				oic = setInterval(()=>{
					nub--
					that.ocodetxt = nub+'s'
					if(nub<=0){
						that.ocodetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		async ncodetxtF(){
			var that = this
			if(!this.checkModbile(this.newMobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.newMobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				oic = setInterval(()=>{
					nub--
					that.ncodetxt = nub+'s'
					if(nub<=0){
						that.ncodetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
		// 获取开票信息 列表
		async memberInvoiceList(def){
			if(def){this.pageNum = 1}
			const res = await memberInvoiceList({
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			});
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.kpxxList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 删除开票信息
		async memberInvoicedelete(id){
			const res = await memberInvoicedelete({id});
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.memberInvoiceList(1)
			}else{this.Tips(res.msg,'error')}
		},
		// 获取证书列表
		async memberCertificateList(def){
			if(def){this.pageNum = 1}
			const res = await memberCertificateList({
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			});
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.zsList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			if(this.newsType==2){
				this.articleList()
			}
			if(this.newsType==3){
				this.memberInvoiceList()
			}
		},
		// 更新用户信息 学员
		async authMemberprofile(){
			if(!this.name){this.Tips('请输入真实姓名','error');return}
			if(!this.isCardNo(this.identityCardCode)){this.Tips('请输入真实有效身份证号码','error');return}
			if(!this.educationName){this.Tips('请输入您的学历','error');return}
			if(!this.jobName){this.Tips('请输入您的职称','error');return}
			if(!this.positionName){this.Tips('请输入您的职务','error');return}
			if(!this.regionVal){this.Tips('请选择省市区','error');return}
			if(!this.address){this.Tips('请输入详细地址','error');return}
			
			// if(!this.laborContractImage.length){this.Tips('请上传劳务合同扫描件','error');return}
			
			// var laborContractImage = []
			// this.laborContractImage.forEach((item)=>{
			// 	laborContractImage.push(item.url)
			// })
			var addrTxt = []
			this.regionList.forEach((i)=>{
				if(i.id==this.regionVal[0]){
					addrTxt.push(i.name)
					i.childList.forEach((j)=>{
						if(j.id==this.regionVal[1]){
							addrTxt.push(j.name)
							j.childList.forEach((k)=>{
								if(k.id==this.regionVal[2]){
									addrTxt.push(k.name)
								}
							})
						}
					})
				}
			})
			// console.log(addrTxt)
			// return
			let res;
			var data = {
				name:this.name,
				identityCardCode:this.identityCardCode,
				gender:this.gender,
				birthday:this.birthday,
				educationName:this.educationName,
				jobName:this.jobName,
				positionName:this.positionName,
				courseCategoryId:this.catVar[1],
				
				provinceId:this.regionVal[0],
				cityId:this.regionVal[1],
				districtId:this.regionVal[2],
				
				provinceName:addrTxt[0],
				cityName:addrTxt[1],
				districtName:addrTxt[2],
				
				address:this.address,
				identityCardFrontImage:this.identityCardFrontImage,
				identityCardBackImage:this.identityCardBackImage,
				diplomaImage:this.diplomaImage,
				portrait:this.portrait,
				laborContractImage:this.laborContractImage,
				socialSecurityImage:this.socialSecurityImage,
				physicalImage:this.physicalImage,
				signatureImage:this.signatureImage,
			}
			res = await authMemberprofile(data);
			if(res.code==200){
				this.getinfo()
				this.Tips(res.msg,'success')
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息 学员
		async getinfo(){
			let res;
			res = await authMemberInfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
				this.manInfo = res.data.member
				this.companyInfo = res.data.company
				
				if(this.companyInfo.status==1){
					this.Tips('企业信息异常','error')
					setTimeout(()=>{
						this.link('/qyInfoRemake')
					},1500)
				}
				
				if(this.manInfo.provinceId){
					this.regionVal = [this.manInfo.provinceId,this.manInfo.cityId,this.manInfo.districtId]
				}
				// this.manInfo.courseCategoryId
				for(var i in this.catArr){
					for(var j in this.catArr[i].childList){
						if(this.catArr[i].childList[j].id==this.manInfo.courseCategoryId){
							this.catVar = [this.catArr[i].id,this.manInfo.courseCategoryId]
						}
					}
				}
				this.portrait = this.manInfo.portrait
				this.name = this.manInfo.name
				this.identityCardCode = this.manInfo.identityCardCode
				this.gender = this.manInfo.gender*1
				this.birthday = this.manInfo.birthday
				this.jobName = this.manInfo.jobName
				this.positionName = this.manInfo.positionName
				this.educationName = this.manInfo.educationName
				this.address = this.manInfo.address
				this.identityCardFrontImage = this.manInfo.identityCardFrontImage
				this.identityCardBackImage = this.manInfo.identityCardBackImage
				this.diplomaImage = this.manInfo.diplomaImage
				this.signatureImage = this.manInfo.signatureImage
				
				
				if(!this.laborContractImage.length){
					var laborContractImage = []
					this.manInfo.laborContractImage.forEach((item)=>{
						laborContractImage.push({
							name:item,
							url:item,
						})
					})
					this.laborContractImageCS = laborContractImage
				}
				this.laborContractImage = this.manInfo.laborContractImage

				
				this.socialSecurityImage = this.manInfo.socialSecurityImage
				this.physicalImage = this.manInfo.physicalImage
				this.mobileSuss = this.manInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
				this.mobile = this.manInfo.mobile
			}else{this.Tips(res.msg,'error')}
		},
		// 存储用户信息
		async storeUinfo(){
			let res;
			res = await authMemberInfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
			}else{this.Tips(res.msg,'error')}
		},
		// 获取tree结构的列表
		async regioncityTree(){
			let res = await regioncityTree({});
			if(res.code==200){
				this.regionList = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 获取课程分类
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				// res.data.categoryList.forEach((item)=>{
				// 	item.childList = [{
				// 		id:item.id,
				// 		categoryName:'全部', 
				// 	},...item.childList]
				// })
				for(var i in res.data.categoryList){
					for(var j in res.data.categoryList[i].childList){
						delete res.data.categoryList[i].childList[j]['childList'];
					}
				}
				this.catArr = res.data.categoryList
			}else{this.Tips(res.msg,'error')}
		},
		idcardF(){
			this.birthday = this.idCard(this.identityCardCode,1)
			this.gender = this.idCard(this.identityCardCode,4)
		},
		//通过身份证号计算年龄、性别、出生日期
		idCard(userCard, num) {
			//获取出生日期
			var birth ;
			if (num == 1) {
				birth = userCard.substring(6, 10) + "-" + userCard.substring(10, 12) + "-" + userCard.substring(12, 14);
				return birth;
			}
			//获取性别
			if (num == 2) {
				if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
					return "男";
				} else {
					return "女";
				}
			}
			if (num == 4) {
				if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
					return "1";
				} else {
					return "2";
				}
			}
			//获取年龄
			if (num == 3) {
				var myDate = new Date();
				var month = myDate.getMonth() + 1;
				var day = myDate.getDate();
				var age = myDate.getFullYear() - userCard.substring(6, 10) - 1;
				if (userCard.substring(10, 12) < month || userCard.substring(10, 12) == month && userCard.substring(12, 14) <= day) {
					age++;
				}
				return age;
			}
		},
		isCardNo(card){
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if(reg.test(card) === false){
				// alert("身份证输入不合法");
				return  false;
			}else{
				return true
			}
		},
		// 身份证正面
		idCardF1(file) {
			if(file.response){
				this.identityCardFrontImage = file.response.data.url;
			}
		},
		// 身份证反面
		idCardF2(file) {
			if(file.response){
				this.identityCardBackImage = file.response.data.url;
			}
		},
		// 毕业证照片
		byzimgF(file) {
			if(file.response){
				this.diplomaImage = file.response.data.url;
			}
		},
		// 上传头像
		uplinkportrait(file) {
			if(file.response){
				this.portrait = file.response.data.url;
			}
		},
		// 劳动合同 照片
		ldhtimgF(response,file,fileList) {
			if(response.code==200){
				this.laborContractImage.push(response.data.url)
			}else{
				this.Tips(response.msg,'error');
				let index = 0;
				for(const i in fileList){
					if(fileList[i]==file){
						index=i;
						break;
					}
				}
				fileList.splice(index,1);
			}
		},
		handleRemove(file, fileList) {
			// console.log(fileList);
			var laborContractImage = []
			fileList.forEach((item)=>{
				if(item.response){
					laborContractImage.push(item.response.data.url)
				}else{
					laborContractImage.push(item.url)
				}
			})
			this.laborContractImage = laborContractImage
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		// 社保 照片
		shebaoImgf(file) {
			if(file.response){
				this.socialSecurityImage = file.response.data.url;
			}
		},
		tjImgf(file) {
			if(file.response){
				this.physicalImage = file.response.data.url;
			}
		},
		// 获取上传图
		// handlePictureCardPreview(file) {
		// 	if(file.response){
		// 		this.reg_businessLicense = file.response.data.url;
		// 	}
		// },
		handleReset() {
			this.$refs.esign.reset();
		},
		//生成签名图片..
		handleGenerate() {
			this.$refs.esign.generate().then(res => {
				let fileName = "img1.png";
				let file = this.dataURLtoFile(res, fileName);
				console.log("file", file);
				this.upImg(file)
			}).catch(err => {
				this.Tips('请先签名','error')
				// alert(err) // 画布没有签字时会执行这里 'Not Signned'
			})
		},
		async upImg(file){
			var that = this
			try {
				const response = await axios.post(this.uplink, {file}, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				// this.uploadStatus = '上传成功！';
				this.signatureImage = response.data.data.url+''; // 假设API返回图片URL
				this.hbQianmin = false
			} catch (error) {
				// console.error('上传失败:', error);
				// this.uploadStatus = '上传失败: ' + (error.response?.data?.message || error.message);
			}
		},
		//将图片base64转换为文件
		dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 24px;
	padding-bottom: 40px;
}
.shStatus{
	width: 1520px;
	height: 60px;
	padding: 0 23px;
	position: relative;
	background: #3B6492;
	margin-top: 23px;
	.i1{
		position: absolute;
		width: 100%;
		height: 60px;
		left: 0;
		top: 0;
	}
	.i2{
		width: 28px;
		margin-right: 8px;
	}
	p{
		font-size: 14px;
		color: #fff;
	}
}
.tips{
	padding-bottom: 12px;
	margin-top: -8px;
	color: #999;
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	padding: 0 10px;
	p{
		padding-top: 24px;
		padding-bottom: 16px;
		margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #3B6492;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.userMsg{
	padding-left: 8px;
	padding-top: 6px;
	padding-right: 64px;
	// padding-bottom: 50px;
	.pageAnniuBox{
		margin-top: 40px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
			cursor: pointer;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}

	.userImg{
		width: 680px;
		// margin-right: 94px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			.el-image{
				width: 134px;
				height: 134px;
				border-radius: 6px;
			}
		}
	}
	.userImgBox{
		width: 680px;
		.itm{
			width: 202px;
			margin-right: 32px;
			&:last-child{
				margin-right: 0;
			}
			.lable{
				font-size: 16px;
				color: #3B3C3E;
				font-weight: bold;
				padding-top: 26px;
				padding-bottom: 12px;
				span{
					font-size: 14px;
					color: #969696;
					font-weight: normal;
				}
			}
			.detail{
				.el-image{
					width: 202px;
					height: 134px;
					border-radius: 6px;
				}
			}
		}
		.itm2{
			// width: 202px;
			margin-right: 32px;
			&:last-child{
				margin-right: 0;
			}
			.lable{
				font-size: 16px;
				color: #3B3C3E;
				font-weight: bold;
				padding-top: 26px;
				padding-bottom: 12px;
				span{
					font-size: 14px;
					color: #969696;
					font-weight: normal;
				}
			}
			.detail{
				::v-deep .el-upload{
					width: 134px;
					height: 134px;
					border: none;
				}
				::v-deep .el-upload-list__item{
					width: 134px;
					height: 134px;
				}
				.el-image{
					width: 134px;
					height: 134px;
					// border-radius: 6px;
				}
			}
		}
	}
	.company{
		width: 680px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			.el-image{
				width: 134px;
				height: 134px;
				border-radius: 6px;
				margin-right: 17px;
			}
			.r{
				width: calc(100% - 151px);
				.name{
					font-size: 18px;
					color: #3B3C3E;
					margin-bottom: 12px;
					font-weight: bold;
				}
				.t1{
					font-size: 16px;
					color: #3B3C3E;
					margin-bottom: 6px;
				}
			}
		}
	}
	.formBox{
		width: 680px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			width: 100%;
			height: 46px;
			border-radius: 6px;
			border: 1px solid #E8EDF4;
			background: #FBFCFF;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
			::v-deep .el-input__icon{
				display: none!important;
			}
		}
		.selAddr{
			.selAddrItm{
				width: 212px;
				height: 46px;
				border-radius: 6px;
				border: 1px solid #E8EDF4;
				background: #FBFCFF;
				margin-right: 22px;
				&:last-child{
					margin-right: 0;
				}
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					height: 44px;
					background: transparent;
				}
			}
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 41px;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.nowpone{
		font-size: 16px;
		color: #3B6492;
		margin-bottom: 24px;
		text-align: center;
	}
	.iptBox{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		justify-content: center;
		.lable{
			font-size: 16px;
			color: #9A9DA7;
			margin-right: 30px;
		}
		.code{
			.el-input{
				width: calc(100% - 106px)!important;
			}
			.codeBtn{
				color: #3B6492;
				font-size: 16px;
				cursor: pointer;
			}
		}
		.ipt{
			width: 307px;
			height: 46px;
			border-radius: 8px;
			border: 1px solid #E8EDF4;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
		}
	}
	.btnBox{
		margin-top: 32px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.cardTable{
	border: 1px solid #EBEEF5;
	border-bottom: 0;
	margin-top: 24px;
	// margin-bottom: 40px;
	.th{
		height: 40px;
		background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
		p{
			line-height: 40px;
			text-align: center;
			font-size: 14px;
			color: #333333;
			font-weight: bold;
		}
		.t1{
			width: 80px;
		}
		.t2{
			width: 184px;
		}
		.t3{
			width: 340px;
		}
		.t4{
			width: 304px;
		}
		.t5{
			width: 190px;
		}
		.t6{
			width: 115px;
		}
		.t7{
			width: 165px;
		}
		.t8{
			width: 146px;
		}
	}
	.td{
		border-bottom: 1px solid #EBEEF5;
		align-items: stretch;
		>div{
			line-height: 26px;
			text-align: center;
			font-size: 14px;
			color: #333333;
			border-right: 1px solid #EBEEF5;
			padding: 8px 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			&:last-child{
				border: none;
			}
		}
		.t1{
			width: 80px;
		}
		.t2{
			width: 184px;
		}
		.t3{
			width: 340px;
		}
		.t4{
			width: 304px;
		}
		.t5{
			width: 190px;
		}
		.t6{
			width: 115px;
		}
		.t7{
			width: 165px;
		}
		.t8{
			width: 146px;
			color: #3B6492;
			cursor: pointer;
		}
	}
}
.kpBox{
	.pageAnniuBox{
		margin-top: 24px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
			cursor: pointer;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}
	.kfpTable{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		margin-top: 24px;
		// margin-bottom: 40px;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 370px;
			}
			.t4{
				width: 476px;
			}
			.t6{
				width: 234px;
			}
			.t7{
				width: 169px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				line-height: 26px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 16px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 370px;
			}
			.t4{
				width: 476px;
			}
			.t6{
				width: 234px;
			}
			.t7{
				width: 169px;
				.bor{
					width: 1px;
					height: 14px;
					background: #E2E2E2;
					margin: 0 18px;
				}
				.txt1{
					font-size: 14px;
					color: #3B6492;
					cursor: pointer;
				}
				.txt2{
					font-size: 14px;
					color: #FF5F5A;
					cursor: pointer;
				}
			}
		}
	}
}
.subTipsQm{
	position: fixed;
	width: 662px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 662px;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.qianMin{
		width: 598px;
		// height: 270px;
		border: 1px dashed #D9D9D9;
		border-radius: 11px;
		margin: auto;
		margin-top: 32px;
	}
	.t1{
		font-size: 16px;
		color: #333333;
		padding-left: 40px;
		margin-top: 18px;
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>